import { type Enum } from '@webapp/utils'

export const AuthenticationErrorTypes = {
  STAFF_ACCESS_EXPIRED: 'STAFF_ACCESS_EXPIRED',
} as const

export type AuthenticationErrorType = Enum<typeof AuthenticationErrorTypes>
